import { render, staticRenderFns } from "./MultiEditorLanguages.vue?vue&type=template&id=2b7d84e3"
import script from "./MultiEditorLanguages.vue?vue&type=script&lang=js"
export * from "./MultiEditorLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports